import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 4054A322-F348-49BA-B85F-B978EFC1BDAD
 * name panorama
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/panorama.svg
 * tags
 * - Photography 
 */
export const PanoramaIcon = createSvgIcon(<><path d="M8.5,12.5L11,15.5L14.5,11L19,17H5M23,18V6A2,2 0 0,0 21,4H3A2,2 0 0,0 1,6V18A2,2 0 0,0 3,20H21A2,2 0 0,0 23,18Z" /></>, 'PanoramaIcon');
export default PanoramaIcon